import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { FeedbackService } from '../../../services/feedback.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";

@Component({
  selector: 'app-feedback-submit',
  templateUrl: './feedback-submit.component.html',
  styleUrls: ['./feedback-submit.component.scss']
})
export class FeedbackSubmitComponent implements OnInit {

    constructor(private route: ActivatedRoute, private _router: Router, private authentication: AuthenticationService, private common: CommonService, private feedbackService: FeedbackService) { }

    feedbackType: any[] = [];
    feedbackCategory: any[] = [];

    SelectedFeedbackType: any = '';
    SelectedFeedbackCategory: any = '';

    btnVerifyText = "SEND";
    btnVerifyDisabled = false;
    descriptionTypeLabel: string = "";
    descriptionCategoryLabel: string = "";

    pagecode: string = "feedback-submit";
    module: string = "feedback";
    accessdenied: boolean = false;


    ngOnInit(): void {

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        this.getFeedbackType();
                        this.getFeedbackCategory();

                        window.scroll(0, 0);


                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );


        });

    }
    userRequest: any = {
        Topic: "",
        Subject: "",
        SubTopic: "",
        Message: "",
        OwnerId: this.authentication._authentication.id
    };
    formValidation() {
        if (this.userRequest.Subject === '' || this.userRequest.Message === '' || this.SelectedFeedbackType === '' || this.SelectedFeedbackCategory === '') {
            this.common.ShowMessage('error', 'Feedback Subject and Message are mandatory!', '')
            return false;
        }
        else {
            return true;
        }
    }
    selectTypeOption(evt: any) {

        var optionValue = evt.target.value;
        var item = this.feedbackType.find(s => s.code == optionValue);
        this.SelectedFeedbackType = item;
        this.descriptionTypeLabel = item.descriptionLabel;
    }
    selectCategoryOption(evt: any) {

        var optionValue = evt.target.value;
        var item = this.feedbackCategory.find(s => s.code == optionValue);
        this.SelectedFeedbackCategory = item;
        this.descriptionCategoryLabel = item.descriptionLabel;
    }
    getFeedbackType() {
        this.feedbackService.getFeedbackType().subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data != null) {
                        this.feedbackType = res.data;
                        if (this.feedbackType.length > 0) {
                            this.descriptionTypeLabel = this.feedbackType[0].descriptionLabel;
                            this.SelectedFeedbackType = this.feedbackType[0];
                        }
                    }
                    else
                        console.warn("Web/Feedback/getFeedbackType()", "feedback for data is null");
                }
                else {
                    console.error("Web/Feedback/getFeedbackType()", res);
                }
            },
            (err: any) => {
                console.error("Web/Feedback/getFeedbackType()", err);
            }
        );
    }
    getFeedbackCategory() {
        this.feedbackService.getFeedbackCategory().subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data != null) {
                        this.feedbackCategory = res.data;
                        if (this.feedbackCategory.length > 0) {
                            this.descriptionCategoryLabel = this.feedbackCategory[0].descriptionLabel;
                            this.SelectedFeedbackCategory = this.feedbackCategory[0];
                        }
                    }
                    else
                        console.warn("Web/Feedback/getFeedbackCategory()", "feedback for data is null");
                }
                else {
                    console.error("Web/Feedback/getFeedbackCategory()", res);
                }
            },
            (err: any) => {
                console.error("Web/Feedback/getFeedbackCategory()", err);
            }
        );
    }

    addFeedback() {
        if (this.formValidation()) {

            this.btnVerifyText = "Sending...";
            this.btnVerifyDisabled = true;
            this.userRequest.Topic = this.SelectedFeedbackType.code;
            this.userRequest.SubTopic = this.SelectedFeedbackCategory.code;

            this.feedbackService.submitFeedback(this.userRequest).subscribe(
                (res: any) => {
                    this.btnVerifyText = "SEND";
                    //console.log("addFeedback success");
                    //console.log(res)

                    this.btnVerifyDisabled = false;

                    if (res.success) {

                        this.userRequest = {
                            Topic: "",
                            Subject: "",
                            SubTopic: "",
                            Message: "",
                            OwnerId: this.authentication._authentication.id
                        };

                        var msg = 'Your feedback has been successfully created. Someone from our team staff will be in touch with you within 24 hours.';
                        // this.toastr.info(msg);
                        this.common.ShowMessage('info', msg, '')
                        this.SelectedFeedbackType = this.feedbackType[0];
                        this.SelectedFeedbackCategory = this.feedbackCategory[0];
                        this._router.navigate(['/feedback/detail/' + res.data.id]);
                    }
                    else {
                        //   this.toastr.error(res, 'Oops!');
                        this.common.ShowMessage('error', res.error_message, '')
                    }
                },
                (err: any) => {
                    this.btnVerifyText = "SEND";
                    this.btnVerifyDisabled = false;
                    console.error("Web/Feedback/Submit/addFeedback()", err);
                }
            );
        }
    }

}

